import EventEmitter from "eventemitter3";
import { addClass, removeClass } from "../../utils/css-utils";
import { addEventListener } from "../../utils/event-utils";
import { MANAGE_CENSUS_EVENT } from "./census";

export default class Form extends EventEmitter {
	constructor($el, census) {
		super();
		this.$el = $el;
		this.census = census;
		this.data = { pseudo: "", name: "", surname: "", email: "" };

		this.init();
	}

	init() {
		this.initDomElements();
		this.addEventListeners();
	}

	initDomElements() {
		this.$inputs = this.$el.querySelectorAll("input");
	}

	addEventListeners() {
		addEventListener(this.$el, "submit", this.setValue.bind(this));

		const $button = this.$el.querySelector("button");
		if ($button) {
			addEventListener($button, "click", (e) => {
				if ($button.type !== "submit") {
					this.setValue(e);
				}
			});
		}
	}

	setValue(e) {
		e.preventDefault();

		this.hasError = false;
		this.data = {};

		this.$inputs.forEach((input) => {
			const row = input.closest(".js-row");
			const value = input.value.trim();

			if (input.name === "pseudo" && !value) {
				this.hasError = true;
				if (row) addClass(row, "error");
			} else {
				if (row) removeClass(row, "error");
			}
			if (input.name) {
				this.data[input.name] = value;
			}
		});

		if (this.hasError) {
			return;
		}

		// On pousse les données dans le census
		this.census.emit(MANAGE_CENSUS_EVENT.SET_ANSWER_VALUE, this.data);
		this.census.emit(MANAGE_CENSUS_EVENT.NEXT_STEP);
	}
}
